export const breakpointNumbers = {
  mobile: 375,
  tablet: 768,
  desktop: 992,
  desktopLg: 1440, // FIXME: figma use 1440 as default desktop size, align this in design system
};

export const breakpoints = {
  mobile: `${breakpointNumbers.mobile}px`,
  tablet: `${breakpointNumbers.tablet}px`,
  desktop: `${breakpointNumbers.desktop}px`,
  desktopLg: `${breakpointNumbers.desktopLg}px`,
};
